
import { ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { TCMSupplier, TCMSupplierService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";

export interface TCMSupplierOptions extends ControllerOptions<TCMSupplier> {

}


export class ClientTCMSupplierService extends BaseClientService implements DataController<TCMSupplier> {

    private _service: TCMSupplierService;


    constructor() {
        super();
        this._service = new TCMSupplierService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMSupplierOptions): Promise<ResultData<TCMSupplier>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: TCMSupplierOptions): Promise<ResultData<TCMSupplier>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMSupplierOptions): Promise<TCMSupplier | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMSupplierOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMSupplierOptions): Promise<TCMSupplier | TCMSupplier[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMSupplierOptions): Promise<TCMSupplier | TCMSupplier[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateNumber(number: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(number, this.token, id)
    }

    public async import(options: TCMSupplierOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMSupplierOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }



}